import React from "react";
import { hasAccess } from "../../app/utils";
import ImportantDocumentsTypes from "../../assets/static/importantDocuments.json";
import AttachmentsContainer from "../../components/AttachmentsContainer/AttachmentsContainer";
import TopLinks from "../../components/TopLinks/TopLinks";

const ImportantDocuments = () => {
  const topLinks = [
    {
      name: "Dashboard",
      path: "/dashboard",
    },
    {
      name: "Important Documents",
      isCurrent: false,
    },
  ];
  return (
    <>
      <TopLinks links={topLinks} />

      <AttachmentsContainer
        sourceTable="DOCS"
        readOnly={!hasAccess({ type: "name", resource: "EDIT_DOCS" })}
        attachmentTypes={ImportantDocumentsTypes}
      />
    </>
  );
};

export default ImportantDocuments;
